<template>
  <v-container fluid>
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="6">
        <v-card>
          <v-toolbar color="error"
                     dark
                     flat>
            <v-toolbar-title>
              Not Authorized
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div>
              You don't have permission to do that.
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn :to="{name: 'library.home'}">
              Content Library
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  metaInfo() {
    this.$store.commit('setTitle', `Not Authorized`);
    return {
      title: this.$store.getters.title,
    }
  },
}
</script>
